
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blog/baby-night-crying",
      function () {
        return require("private-next-pages/blog/baby-night-crying.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blog/baby-night-crying"])
      });
    }
  